import { render, staticRenderFns } from "./TagsList.vue?vue&type=template&id=079761ae&"
import script from "./TagsList.vue?vue&type=script&lang=ts&"
export * from "./TagsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports